import styles from "./CompliancePolicyPage.module.css";

const CompliancePolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Πολιτική Συμμόρφωσης</h1>
      <p>
        Η εταιρεία <strong>THE RECORDS HUB S.A.</strong> δεσμεύεται να
        διασφαλίσει τη συμμόρφωση με όλες τις ισχύουσες νομικές, κανονιστικές
        και δεοντολογικές απαιτήσεις, διασφαλίζοντας παράλληλα την υιοθέτηση
        βέλτιστων πρακτικών στις επιχειρηματικές της διαδικασίες. Αυτή η
        Πολιτική Συμμόρφωσης είναι σύμφωνη με το πρότυπο ISO 37301:2021 και
        στοχεύει στη δημιουργία ενός αποτελεσματικού Συστήματος Διαχείρισης
        Συμμόρφωσης.
      </p>

      <p>
        Η εταιρεία αναγνωρίζει ότι η συμμόρφωση είναι βασικό στοιχείο της
        μακροχρόνιας επιτυχίας και της εμπιστοσύνης των πελατών, των συνεργατών
        και των ενδιαφερόμενων μερών. Δεσμευόμαστε να διασφαλίσουμε ότι οι
        δραστηριότητές μας εκτελούνται με διαφάνεια, ακεραιότητα και σύμφωνα με
        τις ισχύουσες νομικές και κανονιστικές απαιτήσεις.
      </p>

      <h2>Το Σύστημα Διαχείρισης Συμμόρφωσης καλύπτει το παρακάτω πεδίο:</h2>
      <ul>
        <li>
          Ασφαλής Ψηφιοποίηση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη Μορφή
        </li>
        <li>
          Ασφαλής Φύλαξη Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Ασφαλής Διαχείριση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή:
          <ul>
            <li>Μεταφορά</li>
            <li>Καταγραφή / Καταλογογράφηση</li>
            <li>Αρχειοθέτηση</li>
            <li>
              Προεπισκόπηση και Αναζήτηση Μεταδεδομένων στη Διαχείριση Αρχείων
            </li>
          </ul>
        </li>
        <li>
          Ασφαλής Καταστροφή Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Συμβουλευτικές Υπηρεσίες για τη Διαχείριση Αρχείων (Records
          Management) Πελατών της Εταιρείας μας
        </li>
        <li>Συμβουλευτικές Υπηρεσίες DPO / GDPR</li>
      </ul>

      <h2>Στρατηγικοί στόχοι της εταιρείας είναι:</h2>
      <ul>
        <li>
          Συμμόρφωση με όλες τις ισχύουσες τοπικές, εθνικές και διεθνείς νομικές
          απαιτήσεις, κανονισμούς και πρότυπα που σχετίζονται με τις
          δραστηριότητές μας.
        </li>
        <li>
          Διασφάλιση ότι όλες οι επιχειρηματικές μας λειτουργίες είναι σύμφωνες
          με τις συμβατικές υποχρεώσεις μας και τους ηθικούς κανόνες που έχουμε
          υιοθετήσει.
        </li>
        <li>
          Ανάπτυξη και εφαρμογή σαφών εσωτερικών διαδικασιών και πολιτικών που
          να υποστηρίζουν τη συμμόρφωση με τις εξωτερικές και εσωτερικές
          απαιτήσεις.
        </li>
        <li>
          Επικαιροποίηση της πολιτικής και των διαδικασιών σε τακτική βάση, ώστε
          να διασφαλίζεται η συμμόρφωση με τις αλλαγές στη νομοθεσία και τις
          βέλτιστες πρακτικές.
        </li>
        <li>
          Εκπαίδευση και ευαισθητοποίηση στους υπαλλήλους και συνεργάτες σχετικά
          με τη συμμόρφωση, τις υποχρεώσεις τους και τη σημασία της τήρησης των
          κανόνων και των διαδικασιών.
        </li>
        <li>
          Προώθηση της κουλτούρας συμμόρφωσης σε όλα τα επίπεδα της εταιρείας.
        </li>
        <li>
          Ενθάρρυνση της αναφοράς οποιωνδήποτε παραβάσεων της συμμόρφωσης μέσω
          του μηχανισμού αναφοράς.
        </li>
        <li>
          Άμεση διερεύνηση οποιασδήποτε παραβίασης και λήψης των κατάλληλων
          διορθωτικών μέτρων.
        </li>
        <li>
          Εφαρμογή των διαδικασιών πρόληψης παραβάσεων και διαχείρισης κινδύνων
          συμμόρφωσης.
        </li>
        <li>
          Τακτική παρακολούθηση της αποτελεσματικότητας του Συστήματος
          Διαχείρισης Συμμόρφωσης και εφαρμογή βελτιώσεων όπου απαιτείται.
        </li>
      </ul>

      <p>
        Η εταιρεία δεσμεύεται να διασφαλίσει ότι το προσωπικό και οι συνεργάτες
        της κατανοούν την Πολιτική Συμμόρφωσης και είναι ενεργοί συμμετέχοντες
        στην επίτευξη των στόχων ενεργειακής διαχείρισης. Η Πολιτική Συμμόρφωσης
        επανεξετάζεται ετησίως από τη διοίκηση για να διασφαλιστεί ότι συνεχίζει
        να είναι κατάλληλη και σύμφωνη με τις επιχειρηματικές ανάγκες της
        εταιρείας, τις κανονιστικές απαιτήσεις και τις νέες τεχνολογικές
        εξελίξεις.
      </p>
    </div>
  );
};

export default CompliancePolicyPage;
